export const PATHS = {
  root: '/',
  company: {
    index: '/company',
    edit: (id?: string) => `/company/edit/${id || ':id'}`,
    create: '/company/create',
    statistics: '/company/statistics',
    logo: '/company/logo',
  },
  clients: {
    index: '/clients',
  },
  invoices: {
    index: '/invoices',
  },
  importer: {
    index: '/importer',
  },
}



// WEBPACK FOOTER //
// ./src/paths.ts